import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class hubService {

    /******* QUERIES ******/



    /******* TRANSACCIONES ******/

    async notifyExpiration(data) {
        const response = await axios
            .post(`${ERP}administracion/hub/sms-expiration`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async NotifyStock(data) {
        const response = await axios
        .post(`${ERP}administracion/hub/sms-stock`, data)
        .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new hubService();